<div
    class="flex w-full scale-75 flex-col items-center justify-center rounded-lg bg-white px-12 py-14 shadow-far">
    <div class="flex items-center gap-2">
        <app-fa-logo
            class="block w-8"
            [showAdventureTrips]="false"
            theme="dark"
            logoStyle="logo"></app-fa-logo>
        <h4 class="pb-0 text-xl font-bold">Customer Reviews</h4>
    </div>
    <div class="mb-6 mt-4 rounded-full bg-grey-100 px-6 py-2">
        @for (_ of [].constructor(5); track index; let index = $index) {
            <fa-icon [icon]="faStar" class="pr-2 text-orange"></fa-icon>
        }
        <span class="font-bold">5.0 out of 5</span>
    </div>
    <div class="w-full flex-grow">
        <app-customer-reviews-rating-bar
            ratingNumber="5"
            ratingPercentage="100%"
            additionalClasses="mb-4"></app-customer-reviews-rating-bar>
        <app-customer-reviews-rating-bar
            ratingNumber="4"
            additionalClasses="mb-4"
            ratingPercentage="0%"></app-customer-reviews-rating-bar>
        <app-customer-reviews-rating-bar
            ratingNumber="3"
            additionalClasses="mb-4"
            ratingPercentage="0%"></app-customer-reviews-rating-bar>
        <app-customer-reviews-rating-bar
            ratingNumber="2"
            additionalClasses="mb-4"
            ratingPercentage="0%"></app-customer-reviews-rating-bar>
        <app-customer-reviews-rating-bar
            ratingNumber="1"
            ratingPercentage="0%"></app-customer-reviews-rating-bar>
    </div>
</div>
